import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import { PaymentStrings } from "../../../../business/core";
import { PaymentOrdersPageControllerImpl } from "../../../../business/impl";

interface IStrategyButtonBankSlipPayment {
    id: string;
}

export const StrategyButtonBankSlipPayment: React.FC<IStrategyButtonBankSlipPayment> = ({ id }) => {
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState<boolean>(false);
    const strings = PaymentStrings['PTBR'].payment_order.strategy_buttons;

    const handlerRegistryPayment = async () => {
        setLoading(true);

        const putPaymentData = {};
        putPaymentData["payment_order"] = id;

        const controller = new PaymentOrdersPageControllerImpl();
        try {
            const response = await controller.registerPaymentBankInvoice(putPaymentData);
            localStorage.setItem('global-toast', JSON.stringify({ type: 'success', message: response.response.toString() }));
            window.location.reload();
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/dashboard',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                localStorage.setItem('global-toast', JSON.stringify({ type: 'danger', message: 'Erro na requisição' }));
                window.location.reload();
                console.error("Erro na requisição:", error);
            }
        }
    }

    return (
        <Button
            size="sm"
            onClick={() => handlerRegistryPayment()}
            variant={'success'}
            disabled={isLoading}>
            {isLoading
                ? <Spinner size="sm" />
                :
                <>
                    {strings.payment_bank_slip_button_label}
                </>
            }
        </Button>
    )
}